import { CModal, CModalBody, CModalHeader, CModalTitle } from '@coreui/react'
import React, { useEffect } from 'react'
import CompanyModalInfo from './CompanyModalInfo'
// import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { useSelector } from 'react-redux'
import { getBusinessInfoAction, saveBusinessInfoAction } from '../../service/actions/companyAction'
import { useDispatch } from 'react-redux'
import { IRootState } from '../../service/store'
import CustomValuesHook from '../../Hooks/customValuesHook'
import './style.scss'
import CustomModal from '../CroreUIModal'
import FactorIssueTypes from '../../service/enums/FactorIssueType'

const InvoiceType = ({ setInvoiceType }: { setInvoiceType: Function }) => {
    const companyInfo = useSelector((state: IRootState) => state.companyReducer.companyInfo)
    const saveCompanyInfoWaiting = useSelector((state: IRootState) => state.companyReducer.saveCompanyInfoWaiting)
    const dispatch = useDispatch()
    const saveCompanyInfoSuccess: boolean | undefined = useSelector((state: IRootState) => state.companyReducer.saveCompanyInfoSuccess)

    const [states, setStates] = CustomValuesHook({
        factorIssueType: FactorIssueTypes.Real,
        displayGetConfirmModal: false
    })
    useEffect(() => {
        dispatch(getBusinessInfoAction())

    }, [])
    useEffect(() => {
        if (saveCompanyInfoSuccess) {
            dispatch(getBusinessInfoAction())
            setStates({ showModal: false })
        }
    }, [saveCompanyInfoSuccess])
    useEffect(() => {
        if (companyInfo) {

            setStates({

                validCompanyInfo: companyInfo.CompanyName &&
                    companyInfo.NationalCompanyRegistrationNumber &&
                    companyInfo.WorkPostalCode &&
                    companyInfo.WorkAddress,
                factorIssueType: companyInfo?.FactorIssueType === FactorIssueTypes.Legal ? FactorIssueTypes.Legal : FactorIssueTypes.Real
            })
        }

    }, [companyInfo])

    useEffect(() => {
        setInvoiceType(states.factorIssueType)
    }, [states.factorIssueType])

    const handleSubmitBusinessInfo = (values: any) => {
        dispatch(saveBusinessInfoAction(values))
    }
    const issueTypeChangeConfirmModalBody = () => {
        return (<div className='p-3'>
            <div>
                <p style={{ lineHeight: '30px' }}>
                    وضعیت اطلاعات کسب و کار  شما حقوقی ست، مطمئن هستید تمایل دارید فاکتور به صورت حقیقی صادر شود؟پس از تغییر امکان بازگشت وجود ندارد.
                </p>
            </div>
        </div>)
    }

    const issueTypeChangeConfirmModalFooter = () => {
        return (<div className='d-flex justify-content-between'>

            <button className='btn btn-default mx-2' onClick={() => setStates({ displayGetConfirmModal: false })}>انصراف</button>
            <button className='btn btn-primary' onClick={() => {
                setStates({ displayGetConfirmModal: false, factorIssueType: FactorIssueTypes.Real })
            }} >بله فاکتور حقیقی دریافت میکنم</button>
        </div>)
    }
    return (
        <>

            <div className="checkbox-invpiceType" >
                <div className="radio-wrapper">
                    <input type="checkbox" id="invpiceType"
                        onChange={() => {
                            
                            if (states.validCompanyInfo && states.factorIssueType === FactorIssueTypes.Legal) {
                                setStates({ displayGetConfirmModal: true })

                            } else {
                                setStates({ factorIssueType: states.factorIssueType === FactorIssueTypes.Legal ? FactorIssueTypes.Real : FactorIssueTypes.Legal })

                            }
                        }}
                        name="invpiceType"
                        checked={states.factorIssueType === FactorIssueTypes.Legal} />
                    <label htmlFor=" invpiceType">تمایل به دریافت فاکتور “حقوقی” دارم.</label>
                    {!states.validCompanyInfo &&
                        <p>
                            <span>اطلاعات حقوقی‌تان را از اینجا</span>
                            <span className='txt-open-modal' onClick={() => { setStates({ showModal: true }) }}>تکمیل اطلاعات حقوقی </span>
                            <span>کامل نمایید!</span>
                        </p>}
                </div>
            </div>
            <CModal
                backdrop="static"
                keyboard={false}
                portal={false}
                visible={states.showModal}
                onClose={() => setStates({ showModal: false })}
                size={'lg'}
            >
                <CModalHeader >
                    <CModalTitle>تکمیل اطلاعات حقوقی</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <CompanyModalInfo companyInfoModal={companyInfo} waiting={saveCompanyInfoWaiting} save={handleSubmitBusinessInfo} />
                </CModalBody>

            </CModal>
            <CustomModal
                setShow={() => setStates({ displayGetConfirmModal: false })}
                title={"تایید دریافت فاکتور حقیقی"}
                component={issueTypeChangeConfirmModalBody}
                show={states.displayGetConfirmModal}
                footerComponent={issueTypeChangeConfirmModalFooter}
                size={'md'}
                backdrop={true}
            />

        </>
    )
}

export default InvoiceType
